// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/32320279b770148d00a6.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"69c20b28c794c7818446","153":"9222989d7262c1f6d943","154":"2263c7fbce25637a5cfd"}[chunkId] + ".chunk.js";
};